import React from 'react'
import { Button } from "../../Buttons/Button";
import Image from 'react-bootstrap/Image';
import PropTypes from 'prop-types';
import { isSafeImageSrc, isSafeUrl } from "../../../utils";
const MobileView = ({ href_1, href_2, showBtn_2, button_text_2, onClick_2, onClick_1, button_text_1, image, title, titleColor, children }) => {
    return (
        <div className="col-12 col-md-12 action-card-body">
            <div className="row">
                <div
                    data-testid="link-card"
                    className="d-flex col-9"
                >
                    <div className="link-title ">
                        <h2 className="mb-2">
                            <strong className={titleColor}>{title}</strong>
                        </h2>
                        <div className="col-12 mobile-view-child">{children}</div>
                        {showBtn_2 && (
                                <span className="nhs-card-account-info">
                                    Already have an account with{" "}
                                    Patients Know Best?
                                </span>
                        )}
                    </div>
                </div>

                <div className="d-flex justify-content-end align-items-center col-3 p-0">
                    {isSafeImageSrc(image) && <Image src={image} className="nhs-card-image m-0" roundedCircle />}
                </div>
            </div>
                  
            <div className="col-12 d-flex flex-column">
                    <div className="activate-btn-container d-flex flex-column gap-2">
                        <Button
                            className={`btn btn-green`}
                            style={{ minWidth: "160px" }}
                            label={button_text_1}
                            onClick={onClick_1 || null}
                            href={isSafeUrl(href_1) ? href_1 : undefined}
                        />
                        {showBtn_2 && (
                            <Button
                                className={`btn btn-white`}
                                style={{ minWidth: "160px" }}
                                label={button_text_2}
                                href={isSafeUrl(href_2) ? href_2 : undefined}
                                onClick={onClick_2 || null}
                            />
                        )}
                    </div>
            </div>
        </div>
    )
}

MobileView.propTypes = {
    href_1: PropTypes.string,
    href_2: PropTypes.string,
    showBtn_2: PropTypes.bool,
    button_text_1: PropTypes.string.isRequired,
    button_text_2: PropTypes.string,
    onClick_1: PropTypes.func,
    onClick_2: PropTypes.func,
    image: PropTypes.string.isRequired,
    title: PropTypes.string.isRequired,
    titleColor: PropTypes.string,
    children: PropTypes.node
};

export default MobileView